// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3-urv","right":"Footer_right__1dP7v","buttons":"Footer_buttons__19X-l"};